import { CloseOutlined } from '@ant-design/icons';
import { Checkbox, Row, Col, Typography, Tooltip } from 'antd';
import Button from 'antd/es/button';
const { Text } = Typography;

const LayerTreeCustomBoundary = (props) => {
  const { item, rootStyle } = props;
  const name = item.get('name');

  const getLayer = () => {
    let layer_found = null;
    if (props.map.getLayers() && name !== undefined) {
      props.map.getLayers().forEach((layer) => {
        if (layer_found == null) {
          if (layer.getProperties().name == name) {
            layer_found = layer;
          }
        }
      });
    }
    return layer_found;
  };
  const handleCheckboxChange = (event) => {
    let layer = getLayer(item);
    let key = props.getItemKey(item);

    if (layer) {
      layer.setVisible(event.target.checked);
      let newCheckedValues = { ...props.checkedDatasets };
      newCheckedValues[key] = event.target.checked;
      props.setCheckedDatasets(newCheckedValues);
    }
  };
  const removeDatasetFromWorkspace = async () => {
    for (let i = 0; i < props.layersByUser.length; i++) {
      let layer = props.layersByUser[i];
      if (layer.getProperties().name == item.get('name')) {
        let layersByUser = props.layersByUser;
        layersByUser.splice(i, 1);
        props.setLayersByUser(layersByUser);
        props.map.removeLayer(layer);
      }
    }
    let checkedDatasets = { ...props.checkedDatasets };
    checkedDatasets[item.get('name')] = false;
    props.setCheckedDatasets(checkedDatasets);
  };

  return (
    <div>
      <Row style={{ margin: '4px 0' }}>
        <Col span={21}>
          <Checkbox
            style={{
              '--background-color': '#3F7C85',
              '--border-color': '#2B2B2B',
              borderColor: '#2B2B2B',
            }}
            checked={props.checkedDatasets[item.get('name')]}
            onChange={(event) => handleCheckboxChange(event, item)}
          >
            <Text strong style={{ fontSize: 13 }}>
              {item.get('name')}
            </Text>
          </Checkbox>
        </Col>
        <Col span={3}>
          <div style={rootStyle}>
            <Tooltip title={'Remove From Map Viewer'} placement="right">
              <Button
                icon={<CloseOutlined />}
                size={'small'}
                onClick={(event) => removeDatasetFromWorkspace(event, item)}
              ></Button>
            </Tooltip>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default LayerTreeCustomBoundary;
